import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { mapTenantResponse } from '@core/models/tenant.mapper';
import { TenantResponse } from '@core/models/tenant.response';
import { TenantState } from '@core/models/tenant.state';
import { ApiService } from '@core/services/api.service';

import { TenantRepository } from './tenant.repository';

@Injectable()
export class TenantHttpRepository implements TenantRepository {
  private readonly api = inject(ApiService);

  getBySlug(slug: string): Observable<TenantState | null> {
    return this.api
      .get<TenantResponse | null>(`tenants/by-slug/${slug}`)
      .pipe(map(response => (response ? mapTenantResponse(response) : null)));
  }

  getBySubdomain(subdomain: string): Observable<TenantState | null> {
    return this.api
      .get<TenantResponse | null>(`tenants/by-subdomain/${subdomain}`)
      .pipe(map(response => (response ? mapTenantResponse(response) : null)));
  }

  listAll(): Observable<TenantState[]> {
    return this.api.get<TenantResponse[]>('tenants').pipe(map(tenants => tenants.map(mapTenantResponse)));
  }
}
